// @flow

import type { TransportType, PageViewType, EventType, GoalType } from '../';

export default function configure(): TransportType {
  return {
    pageview(options: PageViewType): void {
      console.warn('[trackr]', 'console', 'pageview()', options);
    },
    event(options: EventType): void {
      console.warn('[trackr]', 'console', 'event()', options);
    },
    goal(options: GoalType): void {
      console.warn('[trackr]', 'console', 'goal()', options);
    },
    conversion(options: GoalType): void {
      console.warn('[trackr]', 'console', 'conversion()', options);
    }
  };
}
